module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-greek364.fc40424.woff2";